import { render, staticRenderFns } from "./QuantityCounter.vue?vue&type=template&id=6e7c16b6&"
import script from "./QuantityCounter.vue?vue&type=script&lang=js&"
export * from "./QuantityCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7c16b6')) {
      api.createRecord('6e7c16b6', component.options)
    } else {
      api.reload('6e7c16b6', component.options)
    }
    module.hot.accept("./QuantityCounter.vue?vue&type=template&id=6e7c16b6&", function () {
      api.rerender('6e7c16b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/QuantityCounter.vue"
export default component.exports